// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-bar-typo{
    font-weight: 700;
    background-color: transparent !important;
}

.nav-links a {
    font-size: 18px;
    line-height: 20px;
    font-weight: 700;
    border-bottom: 1px solid transparent;
}

.nav-items-head{
    display: flex;
    gap: 2rem;
}

.nav-Top{
    background-color: #E84427;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    text-decoration: none;
}

.nav-Top-Button{
    background: transparent;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    line-height: 22px;
    border: none;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}


.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
    color: #E84427 !important;
}

.navbar-nav a:hover{
    color: #E84427 !important;
}

.lunch-app a{
    text-decoration: none;
    color: #FFFFFF;
    font-size: 20px;
    text-align: center;
    font-weight: 700;
    width: 100%;
    height: 100%;
    vertical-align: middle;
    padding-top: 6px;
}

.navbar-toggler{
    border: none;
    background-color: unset;
    outline: none;
    padding: 0;
    font-size:30px;
    line-height: 0;
    color:transparent ;
    background-color: transparent;
    border-radius: var(--bs-navbar-toggler-border-radius);
    transition: var(--bs-navbar-toggler-transition);
}

@media screen and (max-width:992px) {
    .nav-items-head{
        gap: 0;
    }
    .navbar-nav a:hover{
        color: unset !important;
        border-color:  #0000002E;
    }
    .navbar_main{
        background: linear-gradient(90deg, #FBF6FF 0%, #FFF1EE 46.5%, #F1F6FF 100%);
        box-shadow: 0px 1px 3.3px 0px #00000040;
        z-index: 999;
    }
    .nav-links a {
        font-size: 16px;
    }
}

@media screen and (max-width: 600px){
    .nav-Top-Button{
        font-size: 14px;
        line-height: normal;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,qDAAqD;IACrD,+CAA+C;AACnD;;AAEA;IACI;QACI,MAAM;IACV;IACA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;QACI,2EAA2E;QAC3E,uCAAuC;QACvC,YAAY;IAChB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;;AAEJ","sourcesContent":[".nav-bar-typo{\n    font-weight: 700;\n    background-color: transparent !important;\n}\n\n.nav-links a {\n    font-size: 18px;\n    line-height: 20px;\n    font-weight: 700;\n    border-bottom: 1px solid transparent;\n}\n\n.nav-items-head{\n    display: flex;\n    gap: 2rem;\n}\n\n.nav-Top{\n    background-color: #E84427;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    text-decoration: none;\n}\n\n.nav-Top-Button{\n    background: transparent;\n    color: #fff;\n    font-size: 1rem;\n    font-weight: 600;\n    line-height: 22px;\n    border: none;\n    outline: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n    color: #E84427 !important;\n}\n\n.navbar-nav a:hover{\n    color: #E84427 !important;\n}\n\n.lunch-app a{\n    text-decoration: none;\n    color: #FFFFFF;\n    font-size: 20px;\n    text-align: center;\n    font-weight: 700;\n    width: 100%;\n    height: 100%;\n    vertical-align: middle;\n    padding-top: 6px;\n}\n\n.navbar-toggler{\n    border: none;\n    background-color: unset;\n    outline: none;\n    padding: 0;\n    font-size:30px;\n    line-height: 0;\n    color:transparent ;\n    background-color: transparent;\n    border-radius: var(--bs-navbar-toggler-border-radius);\n    transition: var(--bs-navbar-toggler-transition);\n}\n\n@media screen and (max-width:992px) {\n    .nav-items-head{\n        gap: 0;\n    }\n    .navbar-nav a:hover{\n        color: unset !important;\n        border-color:  #0000002E;\n    }\n    .navbar_main{\n        background: linear-gradient(90deg, #FBF6FF 0%, #FFF1EE 46.5%, #F1F6FF 100%);\n        box-shadow: 0px 1px 3.3px 0px #00000040;\n        z-index: 999;\n    }\n    .nav-links a {\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width: 600px){\n    .nav-Top-Button{\n        font-size: 14px;\n        line-height: normal;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
